
import { Button } from 'react-bootstrap'

export const Volver = () => (
    <div>
        <Button variant='link' onClick={() => window.history.back()}>
            <i className="bi bi-house mb-4"></i>
            &nbsp;Volver
        </Button>
    </div>
)
